import { Head, Link } from '@inertiajs/inertia-vue3';
import Layout from '@/Shared/Layout';
import TextInput from '@/Shared/TextInput';
import FileInput from '@/Shared/FileInput';
import SelectInput from '@/Shared/SelectInput';
import LoadingButton from '@/Shared/LoadingButton';
import TrashedMessage from '@/Shared/TrashedMessage';
export default {
  components: {
    FileInput: FileInput,
    Head: Head,
    Link: Link,
    LoadingButton: LoadingButton,
    SelectInput: SelectInput,
    TextInput: TextInput,
    TrashedMessage: TrashedMessage
  },
  layout: Layout,
  props: {
    user: Object,
    authUserType: String
  },
  remember: 'form',
  data: function data() {
    return {
      form: this.$inertia.form({
        _method: 'put',
        first_name: this.user.first_name,
        last_name: this.user.last_name,
        email: this.user.email,
        password: '',
        user_type: this.user.user_type,
        photo: null
      })
    };
  },
  methods: {
    update: function update() {
      var _this = this;
      this.form.post("/users/".concat(this.user.id), {
        onSuccess: function onSuccess() {
          return _this.form.reset('password', 'photo');
        }
      });
    },
    destroy: function destroy() {
      if (confirm('Are you sure you want to delete this user?')) {
        this.$inertia["delete"]("/users/".concat(this.user.id));
      }
    },
    restore: function restore() {
      if (confirm('Are you sure you want to restore this user?')) {
        this.$inertia.put("/users/".concat(this.user.id, "/restore"));
      }
    }
  }
};